<template>
    <div class="hello">
        <div class="pieEcharts" ref="rosePie_statistics" style='width:100%;height:100%;'></div>
    </div>
</template>

<script>
    import EChart from 'echarts'

    export default {
        props: {
            types: {
                type: Object,
                default: function () {
                    return {}
                }
            },
        },
        data () {
            return {
                rosePie_statistics: {
                    option: {},
                    chart: null,
                    element: {},

                },
                typeData: {},
                chartArray: ['rosePie_statistics'],
            }
        },
        mounted () {
            this.$nextTick(()=>{
                setTimeout(()=>{
                  window.addEventListener('resize', this.onWindowResize)
                  this.onWindowResize();
              },1500);
            });
        },
        destory () {
            // window.onresize = null;
        },
        beforeDestroy () {
            // this.rosePie_statistics.chart.clear();
            window.removeEventListener('resize', this.onWindowResize, false)
            window.removeEventListener('resize', this.onchartResize, false)
        },
        watch: {
            types: {
                handler: function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        setTimeout(() => {
                            this.pageInit()
                        }, 1000)
                    }
                },
                deep: true
            }
        },
        methods: {
            //根据页面调整
            onWindowResize () {
                // let pageHeight = document.documentElement.clientHeight; //页面总高度
                // let pieStyle = document.querySelectorAll(".type")[0].clientHeight;
                let pieStyle = null
                if (document.querySelectorAll('.left_wrap') && document.querySelectorAll('.left_wrap')[1]) pieStyle = document.querySelectorAll('.left_wrap')[1].clientHeight
                if (document.querySelectorAll('.pieEcharts') && document.querySelectorAll('.pieEcharts')[0]) {
                    document.querySelectorAll('.pieEcharts')[0].style.height = pieStyle - 30 + 'px'  //在这里可以根据你的边距做调整
                    this.onchartResize()
                    if (JSON.stringify(this.types) !== '{}') this.disposeAllChart()
                }
            },
            onchartResize () {
                let chartBox = this.rosePie_statistics.chart
                var width = chartBox.clientWidth
                let option = chartBox.getOption()
                if (width) {
                    chartBox.resize()
                    chartBox.setOption(option, true)
                }
            },

            pageInit () {
                this.typeData = this.$deepClone(this.types)
                this.initData()
            },
            initData () {
                var scale = 1
                var _this = this
                this.rosePie_statistics.option = {
                    tooltip: {
                        trigger: 'item',
                        // formatter: "{b}:{c}%",
                        formatter: function (params, ticket, callback) {
                            var showHtm = ''
                            _this.typeData.series_data.forEach((item, index) => {
                                if (params.dataIndex == index) {

                                    showHtm += item.name + ':' + item.value + '%' + '<br>' + '共' + item.total + '台'

                                }
                            })
                            return showHtm
                        },
                        backgroundColor: 'rgba(0,0,0,0.7)', // 背景
                        padding: [8, 10], //内边距
                        extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
                    },
                    calculable: true,
                    legend: {
                        orient: 'vertical',
                        icon: 'rect',
                        // x: "left",
                        // y: "15%",
                        right: '5%',
                        top: '5%',
                        itemWidth: 12 * scale, // 图例图形宽度
                        itemHeight: 12 * scale, // 图例图形高度
                        textStyle: {
                            color: '#d3d3d1',
                            //   fontSize: 14,  //大
                            fontSize: 12,
                        },
                        // data: [
                        //     "民用",
                        //     "商业",
                        //     "调压箱",
                        // ],
                        icon: 'roundRect',
                        data: this.typeData.name,
                    },
                    series: [
                        {
                            // name: "商品类型占比",
                            type: 'pie',
                            // radius: [30,100],   //大
                            radius: ['25%', '60%'],
                            // avoidLabelOverlap: false,
                            startAngle: 0,
                            center: ['45%', '40%'],
                            roseType: 'area',
                            selectedMode: 'single',
                            label: {
                                // normal: {
                                //     show: true,
                                //     formatter: "{c}%"
                                // },
                                emphasis: {
                                    show: true
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: true,
                                    smooth: false,
                                    length: 10,
                                    length2: 10
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            data: [

                            ]
                        }
                    ]
                }
                var color = ['#1c7ef6', '#ffc600', '#04e0f9','#04e1f9','#02e2f9']
                this.typeData.series_data.forEach((item, index) => {
                    color.forEach((i, n) => {
                        if (index == n) {
                            item.color = i
                            var obj = {
                                value: item.value ? item.value : 0,
                                name: item.name ? item.name : '',
                                itemStyle: {
                                    normal: {
                                        color: i
                                    }
                                }
                            }
                            this.rosePie_statistics.option.series[0].data.push(obj)
                        }
                    })

                })
                var null_data = [{
                    value: 0,
                    name: '',
                    itemStyle: {
                        normal: {
                            color: 'transparent',
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            }
                        }
                    }
                },
                    {
                        value: 0,
                        name: '',
                        itemStyle: {
                            normal: {
                                color: 'transparent',
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        }
                    },
                    {
                        value: 0,
                        name: '',
                        itemStyle: {
                            normal: {
                                color: 'transparent',
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        }
                    },
                    {
                        value: 0,
                        name: '',
                        itemStyle: {
                            normal: {
                                color: 'transparent',
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        }
                    },]
                this.rosePie_statistics.option.series[0].data = this.rosePie_statistics.option.series[0].data.concat(null_data)
                // if(this.rosePie_statistics.chart!=null&&this.rosePie_statistics.chart!=''&&this.rosePie_statistics.chart!=undefined){
                //    this.rosePie_statistics.chart.dispose();
                // }
                console.log('series-=-=-=data-=-=-=-' + JSON.stringify(this.rosePie_statistics.option.series[0].data))
                this.rosePie_statistics.chart = EChart.init(this.$refs.rosePie_statistics)
                // this.rosePie_statistics.chart.resize();
                this.rosePie_statistics.chart.setOption(this.rosePie_statistics.option)
                window.addEventListener('resize', this.onWindowResize)

            },
            //释放图表，销毁对象
            disposeAllChart () {
                let i = 0, len = this.chartArray.length
                for (; i < len; i++) {
                    let a = this.chartArray[i]
                    if (this[a].chart) {
                        this[a].chart.dispose()
                    }
                }
                this.initData()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .hello {
        width: 100%;
        height: 100%;

        .pieEcharts {
            width: 100%;
            height: 100%;
        }
    }

    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .pieEcharts {
        border-right: 0;
        border-left: 0;
        width: 100%;
        /* height:240px; */
        /* background-color: red; */
    }
</style>



// WEBPACK FOOTER //
// src/components/chart/rose_pie.vue